import "./index.css";
import React from "react";

export default function ButtonRow({ brandData, onSave, isSaving }) {
  const siteUrl = `https://ecosystem.life/onboardingsite/${brandData.pathSegment}`;

  const copyLink = () => {
    navigator.clipboard.writeText(siteUrl);
    document.getElementById("notify").click();
  };

  return (
    <div className="button-row">
      <div className="button-row__save-container">
        <button className="preview__save-btn btn btn-green" onClick={onSave}>
          Save changes
        </button>
        {isSaving && (
          <div className="button-row__loading-container">
            <i className="fa fa-1x fa-sync fa-spin text-muted" />
          </div>
        )}
      </div>
      <div className="button-row__container">
        <a
          href={siteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="button-row__external-link btn btn-white btn-brand-hex"
          style={{
            "--hover-text-color": brandData.white ? "white" : "black",
            "--hover-color": brandData.hex || "white",
          }}
        >
          Visit site
        </a>
        <button
          onClick={copyLink}
          className="btn btn-white btn-brand-hex button-row__copy-btn"
          style={{
            "--hover-text-color": brandData.white ? "white" : "black",
            "--hover-color": brandData.hex || "white",
          }}
        >
          Copy site link
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingSite/components/ButtonRow/index.js